import { pipe } from "fp";
import React, { useState, useCallback } from "react";

export type TextContent = string;

export const useTextContent = (): {
  readonly ref: React.Ref<string>;
  readonly textContent: string;
} =>
  pipe(useState(""), ([textContent, update]) => ({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    ref: useCallback((node) => node && update(node.textContent), []),
    textContent,
  }));
